<template>
  <xm-page>
    <xm-page-content >
      <div class="order-detail">
        <div class="header">
          <img src="https://image.xiaomaiketang.com/xm/Jecx5k8XKs.png" class="image" alt="">
          <span class="status" >待支付</span>
        <!--  <span class="status success">已支付</span>
          <span class="status">已取消</span> -->
          <span class="tip">10内付款，超时订单将自动取消</span>
      <!--    <span class="tip">超时未付款，订单自动取消</span> -->
        </div>
        <div class="student">
          <img class="avatar" src="https://image.xiaomaiketang.com/xm/fwxmf84s8n.png" alt="">
          <div>
              <div>
                <span>学生姓名</span>
                <span>18715733456</span>
              </div>
              <div>
                  机构名称机构名称
              </div>
          </div>
        </div>
        <div class="info">
          <div class="title">
            购买项目
          </div>
          <div class="box">
              <div class="box-item">
                  <div class="name">
                      <span>课</span>
                      <span>高二理综强化课</span>
                  </div>
                  <div class="unit">暑假卡（20课时2000元）</div>
                  <div class="num_price">
                      <div class="num"><span>20课时</span><span>含赠送10节课</span></div>
                      <div class="price"><span>¥2400</span><span>¥500</span></div>
                  </div>
              </div>
          </div>
          <div class="total">
              合计：¥6000
          </div>
        </div>

        <div class="order">
          <span class="title">订单信息</span>
          <span class="text">订单号：32618492469</span>
          <span class="text">订单来源：在线商城</span>
          <span class="text">订单类型：报名</span>
          <span class="text">创建时间：2019-01-01 09:00:00</span>
          <span class="text">订单备注：备注信息备注信息备注信息</span>
        </div>
        <div class="footer">
          <mt-button size="large" type="primary" class="footer-btn">取消订单</mt-button>
          <mt-button size="large" type="primary" class="footer-btn">继续支付</mt-button>
        </div>
      </div>
    </xm-page-content>
  </xm-page>
</template>
<script>

export default {
  data() {
    return {
     
    };
  },
  methods: {
 
  }
}
</script>

<style lang="less">
  .order-detail {
    padding-bottom: 0.88rem;
    .header {
      position: relative;
      height: 1.6rem;
      width: 100%;
      background:linear-gradient(270deg,rgba(70,184,255,1) 0%,rgba(22,137,255,1) 100%);
      margin-bottom: 0.2rem;
      .status {
        position: absolute;
        top: 0.32rem;
        left: 0.46rem;
        color: #fff;
        font-size: 0.34rem;
        line-height: 0.48rem;
        &.success {
          top: 0.56rem;
        }
      }
      .tip {
        position: absolute;
        top: 0.92rem;
        left: 0.46rem;
        color: #fff;
        font-size: 0.26rem;
        line-height: 0.36rem;
      }
      .image {
        top: 0.12rem;
        right: 0;
        width: 2.26rem;
        height: 1.24rem;
        position: absolute;
      }
    }
    .student {
      background: #fff;
      height: 1.2rem;
      padding: 0.2rem 0.32rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;
      text-align:left;
      .avatar {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        margin-right: 0.24rem;
      }
    }
    .info {
      background: #fff;
      margin-bottom: 0.2rem;
      padding: 0.2rem 0.3rem;
      .title{
        text-align:left;
      }
      .box {
         border:1px solid #eee;
        .box-item{
            .name{
                text-align:left;
            }
            .unit{
                text-align:left;
            }
            .num_price{
                display: flex;
                justify-content: space-between;
                .num{
                    text-align:left;
                }
            }
        }
      }
      .total{
        text-align:right;
      }
    }
    .order {
      padding: 0.2rem 0.32rem 0.08rem;
      text-align: left;
      background: #fff;
      margin-bottom: 0.2rem;
      .title {
        font-size: 0.3rem;
        color: #333;
        font-weight: 500;
        display: block;
        margin-bottom: 0.12rem;
        line-height: 0.42rem;
      }
      .text {
        font-size: 0.26rem;
        color: #999;
        margin-bottom: 0.12rem;
        display: block;
        line-height: 0.36rem;
      }
    }
    .footer {
      position: fixed;
      display: flex;
      justify-content:space-around;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #fff;
      padding:0.16rem 0;
      .footer-btn{
        width:45%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/module/mall/OrderDetailV5.vue